<template>
	<div class="invitation-login">
		<HeaderVertical title="登录"></HeaderVertical>

		<van-field
			class="input-phone"
			v-model="form.account"
			type="tel"
			placeholder="账号"
		/>
		<van-field
			class="input-phone"
			v-model="form.password"
			type="password"
			placeholder="密码"
		/>
		<div class="common-button btn" @click="handle_login">登录</div>
	</div>
</template>

<script>
import { login_sevenLogin } from '@/api/invitation'
export default {
	data() {
		return {
			form: {
				account: '',
				password: '',
			},

			redirect_url: '', // 登录成功后返回的路由地址
		};
	},
	created() {
		const query = this.$route.query;
		this.redirect_url = query.redirect_url;
	},
	methods: {
		// 校验账号
		verify_account(val) {
			if (!val) {
                this.$toast({
                    type: 'fail',
                    message: '请输入账号',
                })
                return false;
            }
			return true;
		},
		// 校验密码
		verify_password(val) {
			if (!val) {
                this.$toast({
                    type: 'fail',
                    message: '请输入密码',
                })
                return false;
            }
			return true;
		},
		// 校验
		handle_verify() {
			const { account, password } = this.form;
			return (
				this.verify_account(account) && this.verify_password(password)
			);
		},
		// 登录
		handle_login() {
			if (!this.handle_verify()) return;

            
            login_sevenLogin({
                phone: this.form.account,
                pwd: this.form.password
            })
            .then(data => {
                // console.log(data)
                localStorage.setItem('token', `Bearer ${data.token}`)

                this.$toast({
                    type: 'success',
                    message: '登录成功',
                })
                setTimeout(() => {
                    const redirect_url =
                        this.redirect_url || '/activity/vip/invitation/choose_destroy';
                    this.$router.push(redirect_url);
                }, 1000)
            })
            .catch(err => {
                this.$toast({
                    type: 'fail',
                    message: err.msg
                })
            })
		},
	},
};
</script>

<style lang="less" scoped>
@import './invitation_login.less';
</style>
